import { useMemo } from 'react';
import { useGetEditOrActual } from '../../../../../state/CampaignSettings/selectors/useGetEditOrActual';

export const useIsEmbeddedContentBeingUsed = () => {
  const state = useGetEditOrActual();

  return useMemo(() => {
    return !!Object.keys(state.messages)
      .map(k => state.messages[k])
      .filter(s => s.messageType === 'onsite' && s.template?.isEmbedded).length;
  }, [state.messages]);
};
